import React from "react";
import { EditTenantContextProvider } from "./EditTenantView";
import EditTenant from "./views/EditTenant";

const EditTenantPage = () => {
  return (
    <EditTenantContextProvider>
      <EditTenant />
    </EditTenantContextProvider>
  );
};

export default EditTenantPage;
